import React, { Component } from 'react';

class SelectClients extends Component{
    constructor(props){
        super(props);
        this.state = {
            clientId: this.props.clientId
        };
        
        this.handleChange = (event) => {
            const clientId = event.target.value;
            this.props.onSelectClientChange(clientId);
            this.setState({clientId: clientId})
        };
    }

    render(){
        const { clients, title, classname, label, disabledAll } = this.props;
        return(
            <div className={classname}>
                <label className="control-label" htmlFor="selectClient">{label}</label>
                <select className="form-control" value={this.state.clientId} onChange={this.handleChange} title={title}>
                    <option value="0" disabled={disabledAll}>Todos</option>
                    {clients.map((client) => {
                        const nameClient = `${client.nombreCorto}`;
                        return <option key={client.idCliente} value={client.idCliente}>{nameClient}</option>
                    })}
                </select>
            </div>
        )
    }
}

export default SelectClients;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/SelectClients.jsx